import * as types from '../actions/types'
import { UserType } from '../../config/types'
import createReducer from '../createReducer'

const initialState: UserType = {
  isLoaded: false,
  loggedIn: false,
  sessionExpired: false,
  email: null,
  // emailVerified: null,
  skipOnboarding: false,
  id: null,
  patientGroup: 'children',
  patientGroupModalVisible: false,
  emailVerified: null,
  privacyAccepted: null,
  accessToken: null,
  refreshToken: null,
  tokenExpires: null
}

// export const appReady = createReducer(initialState, {
//   [types.INIT_APP](state, action) {
//     return true
//   }
// })

export const user = createReducer(initialState, {
  [types.REFRESH_USER](state, action) {
    const {
      accessToken, refreshToken, tokenExpires
    } = action.payload

    return {
      ...state,
      refreshToken,
      accessToken,
      tokenExpires
    }
  },
  [types.AUTH_LOAD_USER](state, action) {
    const {
      id,
      email,
      accessToken,
      refreshToken,
      tokenExpires,
      skipOnboarding,
      patientGroup,
    } = action.auth

    if (!id) return { ...initialState, skipOnboarding }

    const newState = {
      ...state,
      isLoaded: true,
      loggedIn: true,
      id,
      email,
      accessToken,
      refreshToken,
      tokenExpires,
      ...(skipOnboarding && { skipOnboarding }),
      ...(patientGroup && { patientGroup }),
    }
    return newState
  },
  [types.LOGIN_USER](state, action) {
    const { id, email, accessToken, refreshToken, tokenExpires } = action.payload

    const newState = {
      ...state,
      id,
      email,
      isLoaded: true,
      loggedIn: true,
      patientGroup: 'children', // preset
      patientGroupModalVisible: false,
      accessToken,
      refreshToken,
      tokenExpires
    }
    return newState
  },
  [types.CHANGE_USER_EMAIL](state, action) {
    const { email } = action

    const newState = { ...state, email }
    return newState
  },
  [types.LOGOUT_USER](state, action) {
    const { sessionExpired } = action.payload

    const newState = {
      ...initialState, // initial
      isLoaded: state.isLoaded,
      skipOnboarding: state.skipOnboarding,
      sessionExpired: !!sessionExpired
    }
    return newState
  },
  [types.SET_PROFILE_DATA](state, action) {
    const {
      payload: { id, email, emailVerified, privacyAccepted },
    } = action

    const newState = {
      ...state,
      id,
      email,
      emailVerified,
      privacyAccepted
    }
    return newState
  },
  [types.FINISH_ONBOARDING](state, action) {
    const newState = { ...state, skipOnboarding: true }
    return newState
  },
  [types.SET_PATIENT_GROUP](state, action) {
    const { patientGroup } = action
    const newState = { ...state, patientGroup }
    return newState
  },
  [types.TOGGLE_PATIENT_GROUP_MODAL](state, action) {
    const { patientGroupModalVisible } = action
    const newState = { ...state, patientGroupModalVisible }
    return newState
  },
})
